<rpfsa-user-header headerText="Registration Requests"> </rpfsa-user-header>

<mat-card>
	<rpfsa-customer-user-list-filters 
		[formControl]="filter"
	></rpfsa-customer-user-list-filters>

	<table 
		mat-table 
		class="list-container mb-3" 
		[dataSource]="pagedRegistrationRequests$ | async" 
		matSort
		matSortActive="{{ sort.active }}" 
		matSortDisableClear 
		matSortDirection="{{ sort.direction }}"
	>
		<ng-container matColumnDef="empty">
			<th 
				mat-header-cell 
				*matHeaderCellDef 
				[colSpan]="resultColumns.length" 
				class="text-center"
			>
				<div *ngIf="isLoading$ | async" class="list-loader">
					<mat-progress-bar mode="indeterminate"></mat-progress-bar>
				</div>
				<em> {{ listMessage$ | async }}</em>
			</th>
		</ng-container>

		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef>Name</th>
			<td mat-cell *matCellDef="let request">
				{{ request.firstName }} {{ request.lastName }}
			</td>
		</ng-container>
		<ng-container matColumnDef="email">
			<th mat-header-cell *matHeaderCellDef>Email</th>
			<td mat-cell *matCellDef="let request">{{ request.email }}</td>
		</ng-container>

		<ng-container matColumnDef="company">
			<th mat-header-cell *matHeaderCellDef>Company</th>
			<td mat-cell *matCellDef="let request">
				{{ request.companyName }}
			</td>
		</ng-container>
		<ng-container matColumnDef="phoneNumber">
			<th mat-header-cell *matHeaderCellDef>Phone Number</th>
			<td mat-cell *matCellDef="let request">
				{{ request.phoneNumber }}
			</td>
		</ng-container>

		<ng-container matColumnDef="approve">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let request">
				<div fxLayout>
					<button 
						*ngIf="!request.isRegistered" 
						fxFlex="180px" 
						mat-button 
						color="warn"
						(click)="denyRequest(request.id); request.isDenied = true" 
						[disabled]="request.isDenied"
					>
						<span [innerText]="
								request.isDenied
									? 'Request Denied'
									: 'Deny Request'
							"></span>
					</button>
					<span 
						fxFlex="180px" 
						*ngIf="request.isDenied || request.isRegistered"
					></span>
					<button
						*ngIf="!request.isDenied"
						fxFlex="180px"
						mat-button
						color="primary"
						[routerLink]="usersFragments.addCustomerUser"
						[queryParams]="{ registrationRequestId: request.id }"
						[disabled]="request.isRegistered"
					>
						<span
							[innerText]="
								request.isRegistered
									? 'Request Approved'
									: 'Approve Request'
							"
						></span>
					</button>
				</div>
			</td>
		</ng-container>
		<tr 
			mat-header-row 
			*matHeaderRowDef="resultColumns" 
			[class.hidden]="listMessage$ | async"
		></tr>
		<tr 
			mat-header-row 
			*matHeaderRowDef="emptyColumns" 
			[class.hidden]="!(listMessage$ | async)"
		></tr>
		<tr 
			mat-row 
			*matRowDef="let request; columns: resultColumns" 
			[@animateList]
		></tr>
	</table>

	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator [length]="pagedRegistrationRequestsCount$ | async">
		</mat-paginator>
	</div>
</mat-card>
